// extracted by mini-css-extract-plugin
module.exports = {"Copy":"Copy_Copy__3OU69"};